import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { IRouteReducerSliceStateInit } from "../slice_interface";
import {
  ILabReportLabPartnerResponseData,
  ILabReportListResponseData,
  ILabReportStatsListResponseData,
  ILabReportStatsParamsBody,
  ILabReportStatusResponseData,
} from "@/api_framework/api_modals/LabReport";

export interface ILabReportListState {
  statusList: ILabReportStatusResponseData[] | null;
  labPartnerList: ILabReportLabPartnerResponseData[] | null;
  statsList: ILabReportStatsListResponseData | null;
  labReportListFilter: ILabReportStatsParamsBody | null;
  labReportData: ILabReportListResponseData[] | null;
}

export interface ILabReportListInitialState extends IRouteReducerSliceStateInit {
  state: ILabReportListState;
}

const initialState: ILabReportListInitialState = {
  state: {
    statusList: [],
    labPartnerList: [],
    statsList: null,
    labReportListFilter: null,
    labReportData: [],
  },
};

const labReportListSlice = createSlice({
  name: "lab_report_list_slice",
  initialState: initialState,
  reducers: {
    setStatusList: (
      state,
      action: PayloadAction<{
        data: ILabReportStatusResponseData[];
      }>,
    ) => {
      state.state.statusList = action.payload.data;
    },
    setLabPartnerList: (
      state,
      action: PayloadAction<{
        data: ILabReportLabPartnerResponseData[];
      }>,
    ) => {
      state.state.labPartnerList = action.payload.data;
    },
    setStatsList: (
      state,
      action: PayloadAction<{
        data: ILabReportStatsListResponseData;
      }>,
    ) => {
      state.state.statsList = action.payload.data;
    },
    setLabReportListFilter: (state, action: PayloadAction<ILabReportStatsParamsBody>) => {
      state.state.labReportListFilter = action?.payload;
    },
    setLabReportDataList: (
      state,
      action: PayloadAction<{
        data: ILabReportListResponseData[];
      }>,
    ) => {
      state.state.labReportData = action.payload.data;
    },
  },
});

export const { setStatusList, setLabPartnerList, setStatsList, setLabReportListFilter, setLabReportDataList } =
  labReportListSlice.actions;
export default labReportListSlice.reducer;
